type Props = {
  size?: number;
  color?: string;
  className?: string;
};

export const InsuranceIcon = ({
  size = 16,
  color = "currentColor",
  className,
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 65 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.361328"
        y="0.810791"
        width="64.5451"
        height="64.5451"
        rx="32.2726"
        fill={color}
        fillOpacity="0.21"
      />
      <path
        d="M20.4482 40.1784L25.3639 44.2755C26.0868 44.8774 26.9978 45.2069 27.9384 45.2067H40.8974C41.8226 45.2067 42.5729 44.4565 42.5729 43.5313C42.5729 41.6809 41.0724 40.1784 39.22 40.1784H30.2112M35.9998 20.5679C35.7331 20.5679 35.4773 20.6739 35.2887 20.8625C35.1001 21.0511 34.9942 21.3069 34.9942 21.5736V24.4035H32.1662C31.8995 24.4035 31.6437 24.5095 31.4551 24.6981C31.2665 24.8867 31.1606 25.1425 31.1606 25.4092V28.6776C31.1606 28.9443 31.2665 29.2001 31.4551 29.3887C31.6437 29.5773 31.8995 29.6833 32.1662 29.6833H34.9942V32.5112C34.9942 32.7779 35.1001 33.0337 35.2887 33.2223C35.4773 33.4109 35.7331 33.5169 35.9998 33.5169H39.2683C39.535 33.5169 39.7908 33.4109 39.9794 33.2223C40.168 33.0337 40.2739 32.7779 40.2739 32.5112V29.6833H43.1018C43.3686 29.6833 43.6244 29.5773 43.813 29.3887C44.0016 29.2001 44.1075 28.9443 44.1075 28.6776V25.4092C44.1075 25.1425 44.0016 24.8867 43.813 24.6981C43.6244 24.5095 43.3686 24.4035 43.1018 24.4035H40.2739V21.5716C40.2739 21.3049 40.168 21.0491 39.9794 20.8605C39.7908 20.6719 39.535 20.5659 39.2683 20.5659L35.9998 20.5679Z"
        stroke={color}
        strokeWidth="2.01133"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.4822 38.1687L27.9907 39.6772C28.1888 39.8753 28.424 40.0324 28.6828 40.1397C28.9417 40.2469 29.2191 40.302 29.4992 40.302C29.7794 40.302 30.0568 40.2469 30.3156 40.1397C30.5744 40.0324 30.8096 39.8753 31.0077 39.6772C31.2058 39.4791 31.363 39.2439 31.4702 38.9851C31.5774 38.7263 31.6326 38.4489 31.6326 38.1687C31.6326 37.8886 31.5774 37.6111 31.4702 37.3523C31.363 37.0935 31.2058 36.8583 31.0077 36.6602L28.6665 34.319C27.9123 33.5646 26.8893 33.1406 25.8225 33.1404H20.4482"
        stroke={color}
        strokeWidth="2.01133"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
